<!-- 
	AdminManageNews
	role: Admin
	Allow admins to view edit and create news items 
-->

<template>
	<div class="admin-news text-white">
		<div
			v-if="
				user.loggedIn === true && user.additionalData.isStrideAdmin === true
			"
		>
			<div class="mb-6">
				<CustomButton @click="create = true" class="mx-4"
					>Create News</CustomButton
				>
				<CustomButton
					@click="create = false"
					class="mx-4"
					>View News</CustomButton
				>
			</div>
			<div v-if="this.create === true">
				<CreateNews v-bind:user="user" />
			</div>
			<div v-else>
				<AdminNewsList v-bind:user="user" />
			</div>
		</div>
		<div v-else>
			You must be a Stride Administrator to access this page.<br />If you believe
			this is an error please contact support.
		</div>
	</div>
</template>
<script>
	import { mapGetters } from "vuex";

	import CustomButton from "@/components/CustomButton";
	import AdminNewsList from "@/components/AdminNewsList";
	import CreateNews from "@/components/CreateNews";

	export default {
		name: "AdminManageNews",
		components: {
			CustomButton,
			CreateNews,
			AdminNewsList,
		},
		data() {
			return {
				create: false,
			};
		},
		computed: {
			...mapGetters({
				user: "user",
			}),
		},
	};
</script>
